import axios from 'axios';
import notify from 'devextreme/ui/notify';

export const instance = axios.create({
  timeout: 10000,
})

instance.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    //console.log(error);
    const resp = error.response;
    if (resp) {
      const message = resp.data.errors
        .map(({ message }) => message)
        .join(", ");
      notify(
        {
          closeOnClick: true,
          closeOnOutsideClick: true,
          message
        },
        "error"
      );
    }
    else {
      const message = "Время ожидания ответа с сервера истекло. Попробуйте перезагрузить страницу";
      notify(
        {
          closeOnClick: true,
          closeOnOutsideClick: true,
          message
        },
        "error"
      );
    }
    return Promise.reject(error);
  }
);
